import type { PerformanceConfig } from "./schema";
import { BASE_PACK } from "./base";
import { SENIOR_LIVING_PACK } from "./senior-living";
import { GENERIC_OFFICE_PACK } from "./generic-office";

export * from "./schema";
export * from "./offences";
export { BASE_PACK, SENIOR_LIVING_PACK, GENERIC_OFFICE_PACK };

export type PackId = "base" | "senior_living" | "generic_office";

/**
 * Packs share nested objects through spreads, so one consumer mutating `SENIOR_LIVING_PACK.plans`
 * would change every pack. Freeze them all, in place, once. Copy (`applyOverrides`) to change.
 */
function deepFreeze(value: unknown): void {
  if (typeof value !== "object" || value === null || Object.isFrozen(value)) return;
  Object.freeze(value);
  for (const child of Object.values(value)) deepFreeze(child);
}
for (const pack of [BASE_PACK, SENIOR_LIVING_PACK, GENERIC_OFFICE_PACK]) deepFreeze(pack);

export const PACKS: Record<PackId, PerformanceConfig> = {
  base: BASE_PACK,
  senior_living: SENIOR_LIVING_PACK,
  generic_office: GENERIC_OFFICE_PACK,
};

/**
 * Registry `industry_vertical` → pack. Only senior living has its own; the fixture pack is never
 * returned. A Map, not an object literal: `industry_vertical` is free text, and `"toString"` or
 * `"__proto__"` must fall back to base rather than reach `Object.prototype`.
 */
const PACK_BY_VERTICAL: ReadonlyMap<string, PerformanceConfig> = new Map([
  ["senior_living", SENIOR_LIVING_PACK],
]);

export function packForVertical(vertical: string): PerformanceConfig {
  return PACK_BY_VERTICAL.get(vertical) ?? BASE_PACK;
}
